import { ReviewAndSubmitScreen } from "@/screens/loans/setup/ReviewAndSubmitScreen"
import { router } from "expo-router"

export default function ReviewAndSubmit() {
  return (
    <ReviewAndSubmitScreen
      backButton={() => {
        router.push("./product")
      }}
    />
  )
}
